export const FUNCTIONAL_ERROR = "functional_error";
export const SERVER_ERROR = "server_error";
export const NOT_FOUND_ERROR = "server_error";
export function getErrorType(error: any) {
    if (error.status == 404) {
        return NOT_FOUND_ERROR;
    } else if (error.status >= 400 && error.status < 500) {
        return FUNCTIONAL_ERROR;
    } else {
        return SERVER_ERROR;
    }
}

export function handleErrors(err: any) {
    const errorType = getErrorType(err);

    if (errorType == FUNCTIONAL_ERROR) {
        return err.error.message;
    } else {
        return undefined;
    }
}